import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {MissingComponent} from './missing/missing.component';
import {ProfileComponent} from './profile/profile.component';
import {PostcardComponent} from './postcard/postcard.component';
import {UploadComponent} from './upload/upload.component';
import {SearchComponent} from './search/search.component';
import {AuthGuardService} from './auth-guard.service';
import {AboutComponent} from './about/about.component';

const routes: Routes = [
  {path: '', redirectTo: '/home', pathMatch: 'full'},
  {path: 'home', component: HomeComponent},
  {path: 'profile', component: ProfileComponent, canActivate: [AuthGuardService]},
  {path: 'upload', component: UploadComponent, canActivate: [AuthGuardService]},
  {path: 'search', component: SearchComponent},
  {path: 'postcard/:id', component: PostcardComponent},
  {path: 'about', component: AboutComponent},
  {path: '**', component: MissingComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class RoutingModule {
}
